import React from 'react';

// L'EMBOLCALL DE TOTES LES ETAPES DEL SSM.
//
// ── PER QUÈ CALIA ────────────────────────────────────────────────────────────────────────────
//
// Cada etapa s'inventava la seva classe d'arrel: `flex-1 p-6`, `flex-1 flex`,
// `flex-1 overflow-y-auto p-6`… **i per això el problema del scroll era sistèmic**. A la
// comparació directament no hi havia `overflow-y-auto`: no podia haver funcionat mai.
//
// ── LA CAUSA DE FONS: `min-h-0` ──────────────────────────────────────────────────────────────
//
// En una columna flexible, **un fill té `min-height: auto` per defecte**, que vol dir «com a
// mínim, tan alt com el meu contingut». Amb això, un `overflow-y-auto` **no s'activa mai**: el
// fill creix per sota del contenidor i el que sobra el retalla l'`overflow-hidden` de més amunt.
// El resultat és exactament el que passava: **no hi ha barra de desplaçament i la resta no es
// veu**.
//
// La cura és `min-h-0` a **tota la cadena** de contenidors flexibles, no només al de baix. Al
// projecte sencer no hi era ni una vegada.
//
// Ara hi ha un sol lloc que ho decideix. Una etapa que vulgui gestionar-se ella el desplaçament
// —les que porten llenç— passa `propi`.
export default function MarcEtapa({ children, propi = false, className = '' }) {
  return (
    <div className={`flex-1 min-h-0 ${propi ? 'flex overflow-hidden' : 'overflow-y-auto'} ${className}`}>
      {children}
    </div>
  );
}
